// API Data
export interface IItemCommercialTranslationData {
  id?: number;
  field_name: string;
  language: string;
  text: string;
  identifier: string;
  language_code: string;
  language_description: string;

  manually_created?: boolean;
}

export interface IItemCommercialTranslationFieldErrorData {
  id?: string[];
  field_name: string[];
  language: string[];
  text: string[];
  identifier: string[];
  language_code: string[];
  language_description: string[];
}

// Business Logic Interface
export interface IItemCommercialTranslation
  extends IItemCommercialTranslationData {
  validate(): boolean;
}

export interface IItemCommercialTranslationFieldError
  extends IItemCommercialTranslationFieldErrorData {
  clearErrors(): void;
}

// Constants - Used for validation
export const ITEM_COMMERCIAL_TRANSLATION_MAX_FIELD_NAME_LENGTH = 12;
export const ITEM_COMMERCIAL_TRANSLATION_MAX_IDENTIFIER_LENGTH = 32;
export const ITEM_COMMERCIAL_TRANSLATION_MAX_LANGUAGE_LENGTH = 5;
export const ITEM_COMMERCIAL_TRANSLATION_LANGUAGE_CODE_LENGTH = 3;
export const ITEM_COMMERCIAL_TRANSLATION_MAX_LANGUAGE_DESCRIPTION_LENGTH = 24;
